import TAffix from './affix.vue'

TAffix.install = Vue => {
  Vue.component(TAffix.name, TAffix)
}

export default TAffix



// WEBPACK FOOTER //
// ./src/module/affix/index.js